module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet headerLogo = {}\nif(utils.collectionSize(model.headerLogo) > 0){\nheaderLogo = helpers.detectRenderedImage(model.headerLogo, model._headerLogo) || {}\n}\nconst headerLogoRendered = headerLogo.rendered || {}\nconst url = headerLogoRendered.url || headerLogo.url\n%><section class=\"header\" style=\"width: 100%;\">\n<style>\n.header {\npadding: 0 60px;\n}\n.header .olc {\nfont-family: \"Roboto Condensed\", sans-serif, Arial;\nfont-weight: 400;\nfont-style: normal;\nfont-size: 12px;\nwhite-space: nowrap;\npadding: 0;\ncolor: #777777;\n}\n.header .olc strong {\ncolor: #0062A9;\n}\n.header .logo {\nmax-width: 274px;\n}\n</style>\n<table style=\"width:100%\">\n<tbody>\n<tr>\n<td style=\"text-align: left; width: 300px;\">\n<% if (url){ %><img class=\"logo header-print-logo\" width=\"274\" height=\"44\" alt=\"\" src=\"<%= url %>\"><% } %>\n</td>\n<td class=\"olc\" style=\"width: 165px; padding: 0; line-height: 1.2; vertical-align: top;\">\n<strong>Büro Wels</strong><br>Bahnhofstraße 8, 4600 Wels<br>office@schlager-reisen.at<br>Tel.: +43 7242 - 254 72\n</td>\n<td class=\"olc\" style=\"width: 220px; padding: 0; line-height: 1.2; vertical-align: top;\">\n<strong>Büro Auberg</strong><br>Harafl 21, 4171 Auberg<br>thomas.schoergenhuber@schlager-reisen.at<br>Tel.: +43 676 - 770 38 10\n</td>\n</tr>\n</tbody>\n</table>\n</section>"
  , __filename = "components/templates/core/documents/document/header.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let headerLogo = {}
if(utils.collectionSize(model.headerLogo) > 0){
headerLogo = helpers.detectRenderedImage(model.headerLogo, model._headerLogo) || {}
}
const headerLogoRendered = headerLogo.rendered || {}
const url = headerLogoRendered.url || headerLogo.url

    ; __line = 8
    ; __append("<section class=\"header\" style=\"width: 100%;\">\n<style>\n.header {\npadding: 0 60px;\n}\n.header .olc {\nfont-family: \"Roboto Condensed\", sans-serif, Arial;\nfont-weight: 400;\nfont-style: normal;\nfont-size: 12px;\nwhite-space: nowrap;\npadding: 0;\ncolor: #777777;\n}\n.header .olc strong {\ncolor: #0062A9;\n}\n.header .logo {\nmax-width: 274px;\n}\n</style>\n<table style=\"width:100%\">\n<tbody>\n<tr>\n<td style=\"text-align: left; width: 300px;\">\n")
    ; __line = 33
    ;  if (url){ 
    ; __append("<img class=\"logo header-print-logo\" width=\"274\" height=\"44\" alt=\"\" src=\"")
    ; __append(escapeFn( url ))
    ; __append("\">")
    ;  } 
    ; __append("\n</td>\n<td class=\"olc\" style=\"width: 165px; padding: 0; line-height: 1.2; vertical-align: top;\">\n<strong>Büro Wels</strong><br>Bahnhofstraße 8, 4600 Wels<br>office@schlager-reisen.at<br>Tel.: +43 7242 - 254 72\n</td>\n<td class=\"olc\" style=\"width: 220px; padding: 0; line-height: 1.2; vertical-align: top;\">\n<strong>Büro Auberg</strong><br>Harafl 21, 4171 Auberg<br>thomas.schoergenhuber@schlager-reisen.at<br>Tel.: +43 676 - 770 38 10\n</td>\n</tr>\n</tbody>\n</table>\n</section>")
    ; __line = 44
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/document/header.ejs

}